    import React, { useLayoutEffect, useEffect, useRef, useState } from "react"
import Layout from "../components/layout"
import TransitionLink from 'gatsby-plugin-transition-link'
import { gsap } from "gsap";
import VisibilitySensor from 'react-visibility-sensor'
import ReactPlayer from 'react-player'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { StaticImage } from "gatsby-plugin-image"
import Footer from "../components/footer"
import PjmGlance from "../components/pjm-glance"
import useWindowSize from "../hooks/useWindowDimensions"
import VideoSrc from "../videos/Sprint1_Welcome_3Pillars_DESKTOP.mp4"
import VideoSrcMobile from "../videos/Sprint1_Welcome_3Pillars_MOBILE.mp4"
import nextImage from "../images/Hero_10_Culture.jpg"
import prevImage from "../images/Hero_06_RiskManagement.jpg"
import nextRings from "../images/RINGS_BLUE_MAGENTA.svg"
import prevRings from "../images/RINGS_BLUE_YELLOW.svg"
import innBubble1 from "../images/inn-bubble-1.svg"
import innBubble2 from "../images/inn-bubble-2.svg"
import innBubble3 from "../images/inn-bubble-3.svg"
import innBubble4 from "../images/inn-bubble-4.svg"
import innBubble5 from "../images/inn-bubble-5.svg"
import innArrow from "../images/inn-arrow.svg"
import innCloud from "../images/inn-cloud.svg"
import innPlay from "../images/inn-arrow.svg"
import arrowLeft from "../images/yellow-arrow.svg"
import chevronDown from "../images/angle-down.svg"
import Chart from 'chart.js/auto';
import { Bar } from 'react-chartjs-2';
import { Link } from "gatsby"
import ringsgy from "../images/RINGS_GREEEN_YELLOW.svg"
import ringsmy from "../images/RINGS_MAGENTA_YELLOW.svg"
import ringscy from "../images/RINGS_CYAN_YELLOW.svg"
import ringsbm from "../images/RINGS_BLUE_MAGENTA.svg"
import ringsby from "../images/RINGS_BLUE_YELLOW.svg"
import goldenRings from "../images/RINGS_AllYellow.svg"
import downArrowPink from "../images/down-arrow-pink.svg"
import downArrowGreen from "../images/down-arrow-green.svg"
import downArrowBlue from "../images/down-arrow-blue.svg"   


import "../components/pages.scss"

gsap.registerPlugin(ScrollTrigger);

const InnovationPage = (props) => {
    const size = useWindowSize();
    const firstRow = useRef();
    const circles = useRef([]);
    const navList = useRef();
    const [desktopViewState, setDesktopViewState] = useState(null);
    const rings1 = useRef();
    const rings2 = useRef();
    const rings3 = useRef();
    const date05 = useRef();
    const date19 = useRef();
    const date20 = useRef();
    const amount1 = useRef();
    const amount2 = useRef();
    const amount3 = useRef();
    const direction1 = useRef();
    const direction2 = useRef();
    const direction3 = useRef();
    const [activeTab, setActiveTab] = useState(null);
    const bubble1 = useRef();
    const bubble2 = useRef();
    const bubble3 = useRef();
    const bubble4 = useRef();
    const bubble5 = useRef();
    const secondBubble1 = useRef();
    const secondBubble2 = useRef();
    const secondBubble3 = useRef();

    useEffect(() => {
        const mql = window.matchMedia('(min-width: 1024px)');
        setDesktopViewState(mql.matches);
    }, [size, desktopViewState]);

    useLayoutEffect(() => {
        console.log(circles);
        for(let x = 0; x < circles.current.length; x++) {
            gsap.to(circles.current[x], {
                x: (i, target) => -1000 * target.dataset.speed,
                ease: "none",
                scrollTrigger: {
                    trigger: circles.current[x],
                    scrub: true,
                }
            });
        }

        gsap.from(firstRow.current, { y: 200, ease: "power2"});
        gsap.from(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }, []);

    function handleTabClick(event, date) {
        setActiveTab(event.target);

        let tl = gsap.timeline({paused: true})
        .to(rings1.current, {rotate: 360, scale: 1.35, duration: .5}, "-=.5")
        .to(rings2.current, {rotate: 360, scale: 1.94, duration: .5}, "-=.5")
        .to(rings3.current, {rotate: 360, scale: 1.85, duration: .5}, "-=.5")
        .to(amount1.current, {innerText: 35, duration: .5, snap: {innerText: 1}}, "-=.5")
        .to(amount2.current, {innerText: 94, duration: .5, snap: {innerText: 1}}, "-=.5")
        .to(amount3.current, {innerText: 85, duration: .5, snap: {innerText: 1}}, "-=.5")
        .to(direction1.current, {rotate: 0, duration: .5}, "-=.5")
        .to(direction2.current, {rotate: 0, duration: .5}, "-=.5")
        .to(direction3.current, {rotate: 0, duration: .5}, "-=.5")

        let tl19 = gsap.timeline({paused: true})
        .to(rings1.current, {rotate: 720, scale: 1.01, duration: .5}, "-=.5")
        .to(rings2.current, {rotate: 720, scale: 1.12, duration: .5}, "-=.5")
        .to(rings3.current, {rotate: 720, scale: 1.15, duration: .5}, "-=.5")
        .to(amount1.current, {innerText: 1, duration: .5, snap: {innerText: 1}}, "-=.5")
        .to(amount2.current, {innerText: 12, duration: .5, snap: {innerText: 1}}, "-=.5")
        .to(amount3.current, {innerText: 15, duration: .5, snap: {innerText: 1}}, "-=.5")
        .to(direction1.current, {rotate: 0, duration: .5}, "-=.5")
        .to(direction2.current, {rotate: 0, duration: .5}, "-=.5")
        .to(direction3.current, {rotate: 0, duration: .5}, "-=.5")

        let tl20 = gsap.timeline({paused: true})
        .to(rings1.current, {rotate: 1080, scale: .93, duration: .5}, "-=.5")
        .to(rings2.current, {rotate: 1080, scale: .90, duration: .5}, "-=.5")
        .to(rings3.current, {rotate: 1080, scale: .95, duration: .5}, "-=.5")
        .to(amount1.current, {innerText: 7, duration: .5, snap: {innerText: 1}}, "-=.5")
        .to(amount2.current, {innerText: 10, duration: .5, snap: {innerText: 1}}, "-=.5")
        .to(amount3.current, {innerText: 5, duration: .5, snap: {innerText: 1}}, "-=.5")
        .to(direction1.current, {rotate: 180, duration: .5}, "-=.5")
        .to(direction2.current, {rotate: 180, duration: .5}, "-=.5")
        .to(direction3.current, {rotate: 180, duration: .5}, "-=.5")

        if(date === "date05") {
            tl.play(0);
        }
        if(date === "date19") {            
            tl19.play(0);
        }
        if(date === "date20") {
            tl20.play(0);
        }
    }

    function onChangeData(isVisible) {
        if(isVisible) {
            handleTabClick(date05.current, 'date05');
            setActiveTab(date05.current);
        }
    }
    const [data, setData] = useState({
        datasets: [{
            order: 2,
            type: 'bar',
            label: 'Bar Dataset',
            data: [1292.0264, 851.1926, 791.1457, 843.3056],
            backgroundColor: [
              '#E41087'
            ],
        }, {
            order: 1,
            type: 'line',
            label: 'Line Dataset',
            data: [1292.0264, 851.1926, 791.1457, 843.3056],
            backgroundColor: [
              '#F4C22A'
            ],
            borderColor: '#F4C22A',
        }],
        labels: ['2005', '2019', '2020', '2021']  
    });
    const [data2, setData2] = useState({
        datasets: [{
            order: 2,
            type: 'bar',
            label: 'Bar Dataset',
            data: [8.4906, 0.5465, 0.4287, 0.4812],
            backgroundColor: [
              '#8EBC41'
            ],
        }, {
            order: 1,
            type: 'line',
            label: 'Line Dataset',
            data: [8.4906, 0.5465, 0.4287, 0.4812],
            backgroundColor: [
              '#F4C22A'
            ],
            borderColor: '#F4C22A',
        }],
        labels: ['2005', '2019', '2020', '2021'] 
    });
    const [data3, setData3] = useState({
        datasets: [{
            order: 2,
            type: 'bar',
            label: 'Bar Dataset',
            data: [2.5892, 0.4482, 0.3589, 0.3809],
            backgroundColor: [
              '#6EC2E1'
            ],
        }, {
            order: 1,
            type: 'line',
            label: 'Line Dataset',
            data: [2.5892, 0.4482, 0.3589, 0.3809],
            backgroundColor: [
              '#F4C22A'
            ],
            borderColor: '#F4C22A',
        }],
        labels: ['2005', '2019', '2020', '2021'] 
    });

    const options = {
        plugins:{   
            legend: {
                display: false
            },
        },
        scales: {
            y: {
                ticks: {
                    display: false,
                },
                grid: {
                    display: false,
                    borderColor: "transparent"
                }
            },
            x: {
                ticks: {
                    color: '#FFFFFF',
                    font: {
                        family: 'proxima-nova',
                        size: 16,
                        weight: '700'
                    }
                },
                grid: {
                    display: false,
                    borderColor: "#ffffff",
                    borderWidth: 1
                }
            },
        }
    };

    function onChangeBubbles(isVisible) {
        let tl = gsap.timeline({paused: true})
        .fromTo(bubble1.current, {opacity: 0, x: -100, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.5")
        .fromTo(bubble2.current, {opacity: 0, x: 0, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.45")
        .fromTo(bubble3.current, {opacity: 0, x: 100, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.45")
        .fromTo(bubble4.current, {opacity: 0, x: -100, y: 100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.45")
        .fromTo(bubble5.current, {opacity: 0, x: 100, y: 100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.45")

        if(isVisible) {
            tl.play(0);
        }
    }

    function onChangeSecondBubble(isVisible) {
        let tl = gsap.timeline({paused: true})
        .fromTo(secondBubble1.current, {opacity: 0, x: -100, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.5")
        .fromTo(secondBubble2.current, {opacity: 0, x: 0, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.45")
        .fromTo(secondBubble3.current, {opacity: 0, x: 100, y: -100}, {opacity: 1, x: 0, y: 0, duration: 1.5, ease: 'elastic'}, "-=1.45")

        if(isVisible) {
            tl.play(0);
        }
    }

    return (
        <Layout>
            <main className="page innovation">
                <title>Innovation Page</title>
                <div className="row nav">
                    <div className="col-xs-12">
                        <nav>
                            <ul ref={navList}>
                                <li>
                                    <Link
                                        className="back-button"
                                        activeClassName="active"
                                        to="/"
                                        state={{ pageId: 8 }}
                                    >
                                        <img src={arrowLeft} alt=""/>
                                    </Link>
                                </li>
                                <li className="blue-bar">|</li>
                                <li data-url="innovation" className="text--yellow">Innovation</li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="page-set">
                    <div className="wrapper">
                        <div className="container">
                            <section className="panel">
                                <div className="wrap">
                                    <div className="profile" data-scroll data-scroll-speed="0">
                                        <StaticImage loading="eager" objectFit="contain" placeholder="blurred" quality="50" className="avatar" src="../images/Hero_08_Innovation.jpg" alt="" />
                                        <img className="rings" src={ringscy} alt="" /> 
                                    </div>
                                    <div className="info">
                                        <div data-scroll data-scroll-speed="3" className="title--super text--outline">ADVANCING OUR
                                    </div>
                                        <h1 data-scroll data-scroll-speed="2">EFFORTS</h1>
                                        <div className="button-wrap">
                                            <TransitionLink
                                                className="button"
                                                to="/"
                                            >
                                                Read Lorem
                                            </TransitionLink>
                                        </div>
                                    </div>
                                    <img className="chevron-down" src={chevronDown} alt="" /> 
                                </div>
                                <div
                                    ref={(element) => circles.current[0] = element} 
                                    className="circle--yellow top p-7"
                                    data-speed=".3"
                                ></div>
                                <div
                                    ref={(element) => circles.current[1] = element} 
                                    className="circle--blue top p-7"
                                    data-speed="-.2"
                                ></div>
                                <div
                                    ref={(element) => circles.current[2] = element} 
                                    className="circle--green top p-7"
                                    data-speed="-.3"
                                ></div>
                                <div
                                    ref={(element) => circles.current[3] = element} 
                                    className="circle--pink top p-7"
                                    data-speed="-.1"
                                ></div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper first-row content" ref={firstRow}>
                    <div className="col-xs-12">
                        <p className="text text--large">In the last weeks of 2021, PJM released “<a href="https://pjm.com/-/media/committees-groups/committees/mrc/2021/20211215/20211215-item-09-energy-transition-in-pjm-whitepaper.ashx" target="_blank" className="text-link">The Energy Transition in PJM: Frameworks for Analysis</a>.”</p>
                        <p className="text">This work represented the latest iteration of a multiphase, multiyear effort to analyze the potential impacts of the evolving resource mix, specifically the accelerating integration of renewable resources.</p>
                        <p className="text">Framed as a “living study,” this work helps PJM and stakeholders identify gaps and opportunities in current market constructs and provides insights into the future of market design, transmission planning and reliable system operations.</p>
                        <p className="text">Initial findings concluded that:</p>
                        <ul>
                            <li>Correctly calculating capacity contribution of generators is essential.</li>
                            <li>Flexibility becomes increasingly important with growing uncertainty.</li>
                            <li>Thermal generators provide essential reliability services, and an adequate supply will be needed until a substitute is deployed at scale.</li>
                            <li>Regional markets facilitate a reliable and cost-effective energy transition.</li>
                            <li>Reliability standards must evolve.</li>
                        </ul>
                        <p className="text">The exploration of renewable integration is one of multiple, concurrent initiatives in which PJM serves as an independent source for data and analysis to help facilitate decarbonization and enable the grid of the future.</p>
                    </div>
                </div>
                <VisibilitySensor partialVisibility={true} offset={{top: 100}} onChange={onChangeBubbles}>
                    <div className="row row-wrapper content p-t-40 p-b-40">
                        <div className="col-xs-12">
                            <h6>FRAMEWORK OF ANALYZING ENERGY IN TRANSITION</h6>
                            <div className="bubble-wrap">
                                <div ref={bubble1} className="bubble circle--pink">
                                    <div className="icon">
                                        <div><img src={innBubble1} alt=""/></div>
                                    </div>
                                    <div className="info">
                                        <div className="bubble-title">
                                            Scenario Development
                                        </div>
                                        <div className="bubble-text">
                                            Establishes assumptions for resource portfolios to be used in each piece of analysis. This includes a Base case, a Policy case driven by current state policies, and an Accelerated case factoring in additional state and corporate clean energy goals.
                                        </div>
                                    </div>
                                </div>
                                <div ref={bubble2} className="bubble circle--yellow">
                                    <div className="icon">
                                        <div><img src={innBubble2} alt=""/></div>
                                    </div>
                                    <div className="info">
                                        <div className="bubble-title">
                                            Operational Reliability Assessment 
                                        </div>
                                        <div className="bubble-text">
                                            Examines the impact of each scenario on the reliability attributes of resources and the system.
                                        </div>
                                    </div>
                                </div>
                                <div ref={bubble3} className="bubble circle--blue">
                                    <div className="icon">
                                        <div><img src={innBubble3} alt=""/></div>
                                    </div>
                                    <div className="info">
                                        <div className="bubble-title">
                                            Energy & Ancillary Services Market Simulations
                                        </div>
                                        <div className="bubble-text">
                                            Uses security-constrained unit commitment and economic dispatch simulations to estimate impacts of each scenario on system generation and prices. 
                                        </div>
                                    </div>
                                </div>
                                 <div ref={bubble4} className="bubble circle--green">
                                    <div className="icon">
                                        <div><img src={innBubble4} alt=""/></div>
                                    </div>
                                    <div className="info">
                                        <div className="bubble-title">
                                            Resource Adequacy Assessment
                                        </div>
                                        <div className="bubble-text">
                                            Uses the Effective Load Carrying Capability (ELCC) methodology to determine the capacity value of renewables and installed reserve margins in each scenario.
                                        </div>
                                    </div>
                                </div>
                                 <div ref={bubble5} className="bubble circle--pink">
                                    <div className="icon">
                                        <div><img src={innBubble5} alt=""/></div>
                                    </div>
                                    <div className="info">
                                        <div className="bubble-title">
                                            Transmission Planning Impacts
                                        </div>
                                        <div className="bubble-text">
                                            Assesses transmission needs to reliably develop the future grid and inform how PJM’s planning processes should evolve to meet these needs.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </VisibilitySensor>
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase">Emerging Technologies Forum</h5>
                        <p className="text">The Emerging Technologies Forum (ETF) was established to support PJM’s Advanced Technology Pilot Program (ATPP), which provides a testing ground to study the viability of integrating emerging technologies that enhance system reliability, operational and market efficiency, and resilience. It also provides a forum for PJM states, stakeholders and consumers to share innovative ideas that are shaping the grid of the future.</p>
                        <p className="text">Since 2020, PJM’s ETF has:</p>
                        <ul>
                            <li>Provided education about emerging grid technologies</li>
                            <li>Explored issues concerning operations, planning and markets</li>
                            <li>Enhanced transparency to PJM’s ATPP</li>
                            <li>Shared updates and recommendations with PJM’s senior stakeholder committees</li>
                        </ul>
                        <p className="text"> ETF stakeholder interests include:</p>
                        <ul>
                            <li>Grid-enhancing transmission technologies</li>
                            <li>Distributed energy resources technologies</li>
                            <li>Hydrogen</li>
                        </ul>
                        <h5 className="m-t-60 text--uppercase">Advanced Technology Pilot Program</h5>
                        <p className="text">The ETF supports PJM’s Advanced Technology Pilot Program (ATPP). Pilots are selected according to the value to PJM and its stakeholders, their feasibility and stakeholder input. As an independent and neutral company, PJM does not directly fund pilot projects. PJM provides support through people, data, analysis and/or expertise; in some cases, PJM offers its corporate campus or other physical resources as a test ground for new technology.</p>
                        <p className="text">In 2021, PJM initiated an advanced technology pilot project with Delmarva Power, referred to as the Elk Neck Virtual Power Plant (Elk Neck VPP). The purpose of this pilot is to better understand the operational capabilities and wholesale market challenges associated with a distributed energy resource (DER) use case that has yet to be deployed in PJM markets – aggregated, residential battery storage.</p>
                        <p className="text">This project will serve as a demonstration for both the existing rules that allow this type of resource to participate as demand response in PJM markets, as well as for the potential future market rules that will be established in response to FERC Order 2222 for DER aggregation.</p>
                        <p className="text">The Elk Neck VPP consists of aggregated behind-the-meter batteries located at 110 residential customer homes on the Elk Neck Peninsula in Maryland. </p>
                    </div>
                </div>
                <div className="sec-pad">
                    <div className="row row-wrapper content">
                        <div className="col-xs-12 col-md-5">
                            <div className="profile-wrap">
                                <div className="profile">
                                    <StaticImage loading="lazy" placeholder="blurred" quality="50" objectFit="contain" className="avatar" src="../images/Innovation_DLR.jpg" alt=""/>
                                    <img className="rings" src={ringsbm} alt="" /> 
                                </div>
                            </div>
                       </div>
                        <div className="col-xs-12 col-md-7">
                             <blockquote>
                                 <p className="text--intro">Dynamic line ratings (DLRs) are advanced grid technology on transmission lines that collect real-time data measurements from sensors to report weather conditions and determine equipment ratings with improved accuracy, identifying additional transmission capacity on the monitored transmission line. The data also helps develop short-term rating forecasts for operations planning and day-ahead generation dispatch.</p>
                             </blockquote>
                             <div className="text text--italic">Credit: Ampacimon, Inc</div>
                        </div>
                    </div>
                </div> 
                <div className="bg-blue sec-pad">
                    <div className="row row-wrapper">
                        <div className="col-xs-12 p-t-40">
                            <h2 className="text--center text--yellow">First RTO to share marginal emissions data</h2>
                        </div>
                    </div>
                    <VisibilitySensor partialVisibility={true} offset={{top: 100}} onChange={onChangeSecondBubble}>
                        <div className="row row-wrapper content">
                            <div className="col-xs-12 p-b-40">
                                <div className="bubble-wrap">
                                    <div ref={secondBubble1} className="bubble circle--pink">
                                        <div className="info">
                                            <div className="icon--large">
                                                <div><img src={innArrow} alt=""/></div>
                                            </div>
                                            <div className="bubble-title">
                                                Supports renewable energy goals
                                            </div>
                                        </div>
                                    </div>
                                    <div ref={secondBubble2} className="bubble circle--yellow">
                                        <div className="info">
                                            <div className="icon--large">
                                                <div><img src={innCloud} alt=""/></div>
                                            </div>
                                            <div className="bubble-title">
                                                Allows for tracking of real-time carbon emissions
                                            </div>
                                        </div>
                                    </div>
                                    <div ref={secondBubble3} className="bubble circle--green">
                                        <div className="info">
                                            <div className="icon--large">
                                                <div><img src={innPlay} alt=""/></div>
                                            </div>
                                            <div className="bubble-title">
                                                 Enables users to make strategic decisions about energy consumption
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </VisibilitySensor>
                </div>
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase">PJM Emission Data Enables New Approach To Measure Carbon</h5>
                        <p className="text">A public data stream published by PJM in September provided a new way for companies to analyze and manage their carbon footprints. This marginal emission rate data stream is the first published in real time by an RTO and is publicly available on PJM’s Data Miner tool.</p>
                        <p className="text">General Motors Co. (GM), in partnership with PJM member, TimberRock, announced plans to utilize the PJM marginal emission rates data to help GM reach a goal of 100% renewable energy to power company operations by 2025 – five years earlier than previously announced.</p>
                        <p className="text">The marginal emission rate data, published every five minutes through PJM’s Data Miner tool, provides the weighted emission rate of the marginal units for carbon dioxide, sulfur dioxide and nitrogen oxides on a locational basis.</p>
                        <p className="text">Marginal emission rates can provide an indication of the carbon impact associated with a change in consumer behavior. As a result, data users gain insight into the most emission-efficient times of the day and locations to operate in pursuit of their decarbonization goals.</p>
                    </div>
                </div>
                <div
                    ref={(element) => circles.current[4] = element} 
                    className="circle--pink page-1"
                    data-speed="-.1"
                ></div>
                {desktopViewState &&
                    <div className="row row-wrapper tabs-graph">
                        <div className="col-xs-12 text--center p-t-80">
                            <h5 className="text--uppercase">PJM Average Emissions</h5>
                        </div>
                        <div className="col-xs-12 text--center p-t-10">
                            <h6 className="text--uppercase">SEE DATA FROM</h6>
                            <div className="tabs">
                                <div onClick={(event) => handleTabClick(event, 'date05')} ref={date05} className={`${activeTab === date05.current ? 'active' : null} tab__item`}>2005</div>
                                <div onClick={(event) => handleTabClick(event, 'date19')} ref={date19} className={`${activeTab === date19.current ? 'active' : null} tab__item`}>2019</div>
                                <div onClick={(event) => handleTabClick(event, 'date20')} ref={date20} className={`${activeTab === date20.current ? 'active' : null} tab__item`}>2020</div>
                            </div>
                        </div>
                        <VisibilitySensor partialVisibility={true} offset={{top: 100}} onChange={onChangeData}>
                            <div className="col-xs-12 text--center p-t-40">
                                <div className="tab-content__circle">
                                    <div ref={rings1} className="gold-rings">
                                        <img className="golden-rings" src={goldenRings} alt="" /> 
                                    </div>
                                    <div className="circle--pink">
                                        <div className="info">
                                            <div className="text--large text--white">CO<sub>2</sub></div>
                                            <div className="h4 text--bold text--white">2021</div>
                                        </div>
                                    </div>
                                    <div className="data-amount">
                                        <div className="direction" ref={direction1}><img className="down-arrow-pink" src={downArrowPink} alt="" /></div>
                                        <div className="percent text--pink"><span ref={amount1}>10</span>%</div>
                                    </div>
                                </div>
                                <div className="tab-content__circle">
                                    <div ref={rings2} className="gold-rings">
                                        <img className="golden-rings" src={goldenRings} alt="" /> 
                                    </div>
                                    <div className="circle--green">
                                        <div className="info">
                                            <div className="text--large text--white">SO<sub>2</sub></div>
                                            <div className="h4 text--bold text--white">2021</div>
                                        </div>
                                    </div>
                                    <div className="data-amount">
                                        <div className="direction" ref={direction2}><img className="down-arrow-green" src={downArrowGreen} alt="" /></div>
                                        <div className="percent text--green"><span ref={amount2}>10</span>%</div>
                                    </div>
                                </div>
                                <div className="tab-content__circle">
                                    <div ref={rings3} className="gold-rings">
                                        <img className="golden-rings" src={goldenRings} alt="" /> 
                                    </div>
                                    <div className="circle--blue">
                                        <div className="info">
                                            <div className="text--large text--white">NO<sub>x</sub></div>
                                            <div className="h4 text--bold text--white">2021</div>
                                        </div>
                                    </div>
                                    <div className="data-amount">
                                        <div className="direction" ref={direction3}><img className="down-arrow-blue" src={downArrowBlue} alt="" /></div>
                                        <div className="percent text--lightblue"><span ref={amount3}>10</span>%</div>
                                    </div>
                                </div>
                            </div>
                        </VisibilitySensor>
                    </div>
                }
                {!desktopViewState &&
                    <div className="bg-blue p-t-40 p-b-40 m-t-40">
                        <div className="row row-wrapper">
                            <div className="col-xs-12 text--center">
                                <h2 className="text--yellow">PJM AVERAGE EMISSIONS</h2>
                            </div>
                        </div>
                        <div className="row row-wrapper">
                            <div className="col-xs-12">
                                <div className="data-charts text--center p-t-40">
                                    <h3 className="text--white">CO<sub>2</sub></h3>
                                    <Bar data={data} options={options} />
                                </div>
                                <div className="data-charts text--center p-t-40">
                                    <h3 className="text--white">SO<sub>2</sub></h3>
                                    <Bar data={data2} options={options} />
                                </div>
                                <div className="data-charts text--center p-t-40">
                                    <h3 className="text--white">NO<sub>x</sub></h3>
                                    <Bar data={data3} options={options} />
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className="quote-wrap bg-blue sec-pad">
                    <div className="row row-wrapper content">
                        <div className="col-xs-12">
                            <div className="p-t-40 p-b-40">
                                <div className="row row-wrapper content max--1024">
                                    <div className="col-xs-12 text--center">
                                        <p className="text text--yellow text--large quote-text">“This is a good example of how PJM can leverage subject matter expertise and make data available to help inform stakeholders and policymakers.”</p>
                                        <p className="text text--uppercase text--yellow text--large quote-name">Eric Hsia, Senior Manager – Market Simulation</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer 
                nextLink="/culture-of-caring" 
                nextImage={nextImage}
                nextText="Next &gt;"
                nextTitle="Culture of Caring"
                nextButton="" 
                nextRings={nextRings}
                prevLink="/risk-management" 
                prevImage={prevImage}
                prevText="&lt; Previous"
                prevButton=""
                prevTitle="Risk Management"  
                prevRings={prevRings} 
            />
        </Layout>
    )
}

export default InnovationPage
